/**
 * @fileoverview Столкновения на рулежной дорожке.
 */

import { MAX_VIOL } from "../constants/world";
import { Snd } from "../audio/sound";
import type { GameHooks, GameState, Plane } from "../state/types";
import { pick, rnd } from "../util/math";
import { crash } from "./crash";
import { addScore, breakStreak } from "./scoring";

/**
 * Реальный инцидент на РД (не «предупреждение»).
 * Повторное столкновение (≥2) завершает смену через {@link crash}.
 */
export function taxiCollision(
  g: GameState,
  hooks: GameHooks,
  a: Plane,
  b: Plane,
): void {
  if (!g || g.over || !a || !b || a.dead || b.dead) return;
  if (a._taxiLock || b._taxiLock) return;
  if (a._taxiHit && g.elapsed - a._taxiHit < 3) return;
  if (b._taxiHit && g.elapsed - b._taxiHit < 3) return;

  a._taxiHit = g.elapsed;
  b._taxiHit = g.elapsed;
  a._taxiLock = true;
  b._taxiLock = true;
  a.yieldT = Math.max(a.yieldT || 0, 10);
  b.yieldT = Math.max(b.yieldT || 0, 10);
  a.warn = 1.2;
  b.warn = 1.2;
  a.pat = Math.max(0.15, (a.pat || 1) - 0.22);
  b.pat = Math.max(0.15, (b.pat || 1) - 0.22);

  for (let i = 0; i < 22; i++) {
    g.sparks.push({
      x: (a.x + b.x) / 2 + rnd(-18, 18),
      y: (a.y + b.y) / 2 + rnd(-12, 12),
      vx: rnd(-120, 120),
      vy: rnd(-140, 80),
      t: rnd(0.35, 0.9),
      c: pick(["#ffd06b", "#ff8a4b", "#fff1c2", "#ff6b6b"]),
      s: rnd(1.4, 3.2),
    });
  }

  g.shake = 0.55;
  g.flash = 0.85;
  g.riskyOps += 2;
  g.delays++;
  g.paxMood = Math.max(0, g.paxMood - 12);
  g.hazards = g.hazards.filter(
    (h) => h.p !== a && h.q !== a && h.p !== b && h.q !== b,
  );
  Snd.crash();
  addScore(g, hooks, -100, null, "СТОЛКНОВЕНИЕ НА РД");
  hooks.toast(
    `СТОЛКНОВЕНИЕ: ${a.cs} × ${b.cs} на рулежке — оба остановлены`,
    "bad",
  );
  g.worstMistake = `Столкновение на рулежке (${a.cs} / ${b.cs})`;
  g.taxiHits = (g.taxiHits || 0) + 1;
  g.violations++;
  breakStreak(g, hooks);

  if (g.taxiHits >= 2) {
    crash(
      g,
      hooks,
      a,
      `Повторное столкновение на рулежке (${a.cs} и ${b.cs}). Смена прервана.`,
    );
    return;
  }
  if (g.violations >= MAX_VIOL) {
    hooks.endGame(
      "Смена прервана",
      "Три критических нарушения — вас отстранили от смены.",
    );
  }
}
